import { FileType } from '../../types'
import { resolveAllowedTypesString } from '../resolveAllowedTypesString/resolveAllowedTypesString'

export const isFileExtensionMatch = (fileType: FileType[], fileName: string): boolean => {
  const expectedExtension = resolveAllowedTypesString(fileType, ', ')
  const pattern = new RegExp(
    `(${expectedExtension
      .split(',')
      .map((e) => e.trim().replace('.', '\\.'))
      .join('|')})$`,
    'i',
  )
  return pattern.test(fileName)
}
